<template>
  <div class="workflow-status-form">
    <h6 v-if="title" style="margin: 0 0 12px 0">{{ title }}</h6>

    <div class="row workflow-status-top-row">
      <div class="workflow-status-top-field">
        <label>{{ s__('ProjectSettings|Name') }} *</label>
        <input
          class="status-name-input"
          :value="status.name"
          type="text"
          :placeholder="s__('ProjectSettings|e.g., In Progress, Done')"
          @input="updateField('name', $event.target.value)"
        />
      </div>
      <div class="workflow-status-top-field">
        <label>{{ s__('ProjectSettings|Color') }}</label>
        <input
          class="status-color-input"
          :value="status.color"
          type="color"
          @input="updateField('color', $event.target.value)"
        />
      </div>
    </div>

    <div class="row">
      <div style="flex: 1">
        <label>{{ s__('ProjectSettings|Description') }}</label>
        <input
          :value="status.description"
          type="text"
          :placeholder="s__('ProjectSettings|Optional')"
          @input="updateField('description', $event.target.value)"
        />
      </div>
    </div>

    <div class="row" style="display: flex; gap: 16px">
      <label style="display: flex; align-items: center; gap: 8px">
        <input
          :checked="status.isInitial"
          type="checkbox"
          @change="updateField('isInitial', $event.target.checked)"
        />
        <span>{{ s__('ProjectSettings|Initial status') }}</span>
      </label>
      <label style="display: flex; align-items: center; gap: 8px">
        <input
          :checked="status.isFinal"
          type="checkbox"
          @change="updateField('isFinal', $event.target.checked)"
        />
        <span>{{ s__('ProjectSettings|Final status') }}</span>
      </label>
      <label style="display: flex; align-items: center; gap: 8px">
        <input
          :checked="status.requiresCompletedChecklists"
          type="checkbox"
          @change="updateField('requiresCompletedChecklists', $event.target.checked)"
        />
        <span>{{ s__('ProjectSettings|Require completed checklists') }}</span>
      </label>
    </div>

    <div class="workflow-status-form-actions mobile-stretch-btn-group">
      <button
        :disabled="!canSubmit || submitting"
        class="btn-sm btn-primary"
        @click="$emit('submit')"
      >
        {{ submitting ? submittingText : submitText }}
      </button>
      <button class="btn-sm btn-secondary" @click="$emit('cancel')">
        {{ __('Cancel') }}
      </button>
    </div>

    <div v-if="error" class="error" style="margin-top: 8px">
      {{ error }}
    </div>
  </div>
</template>

<script setup>
import { __, s__ } from '@/locale'

const props = defineProps({
  status: {
    type: Object,
    required: true,
  },
  title: {
    type: String,
    default: '',
  },
  canSubmit: {
    type: Boolean,
    default: false,
  },
  submitting: {
    type: Boolean,
    default: false,
  },
  submitText: {
    type: String,
    required: true,
  },
  submittingText: {
    type: String,
    required: true,
  },
  error: {
    type: String,
    default: '',
  },
})

const emit = defineEmits(['update:status', 'submit', 'cancel'])

function updateField(field, value) {
  emit('update:status', {
    ...props.status,
    [field]: value,
  })
}
</script>

<style scoped>
.workflow-status-top-row {
  display: flex;
  gap: 12px;
}

.workflow-status-top-field {
  flex: 1 1 0;
  min-width: 0;
}

.status-name-input,
.status-color-input {
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
}

.status-color-input {
  height: 40px;
  min-height: 40px;
  padding: 2px;
}

.workflow-status-form-actions {
  display: flex;
  gap: 8px;
  margin-top: 12px;
}

@media (max-width: 768px) {
  .workflow-status-top-row {
    flex-direction: column;
  }
}
</style>
